// extracted by mini-css-extract-plugin
export var cardLayout = "_1q-1";
export var paginationContainer = "_1q-0";